import { createContext } from "react";
import type { LoginFormData } from "@/features/auth/schemas/forms/loginForm.schema";
import type {
  AuthCheck2FAPayload,
  AuthRegisterPhonePayload,
  ImpersonatePayload,
  SessionState,
} from "@/features/auth/types/auth.type";
import type { User, UserResponse } from "@/shared/types";

export type AuthContextType = SessionState & {
  login: (credentials: LoginFormData) => Promise<void>
  check2FA: (payload: Omit<AuthCheck2FAPayload, "otp_challenge">) => Promise<void>
  // Sign-in approved in the Yeati app: one poll of the request; true while it is still pending.
  pollLoginApproval: () => Promise<boolean>
  // Gives up on the app approval for an SMS code (then check2FA as usual).
  fallbackLoginApprovalToSms: () => Promise<void>
  registerPhone: (payload: AuthRegisterPhonePayload) => Promise<void>
  logout: () => Promise<void>
  clearError: () => void
  refreshSession: () => Promise<void>
  impersonate: (payload: ImpersonatePayload) => Promise<void>
  exchangeGrant: (loginToken: string) => Promise<void>
  updateUserState: (updatedUserData: Partial<UserResponse["employee"]>) => void
  completeLegalCompliance: (employeeUpdates?: Partial<User>) => void
  onlineUserIds: Set<string>
  isUserOnline: (userId: number) => boolean
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
